import React, { useState } from "react";
import { useCart } from "../context/CartContext";
import ServiceAPI from "../services/NavaService";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import TopNavbar from "../components/Nav/TopNavbar";

export default function Checkout() {
    const { items, total, clear } = useCart();
    const [saving, setSaving] = useState(false);
    const navigate = useNavigate();

    const getUser = () => {
        try {
            const raw = localStorage.getItem("user");
            return raw ? JSON.parse(raw) : null;
        } catch (e) { return null; }
    };

    const handleCheckout = async () => {
        if (!items || items.length === 0) {
            Swal.fire({ text: "Cart is empty", icon: "warning" });
            return;
        }

        const user = getUser();
        if (!user) {
            Swal.fire({ text: "Please login to checkout", icon: "warning" });
            return;
        }

        const username = user?.username ?? user?.name ?? "unknown";
        const clientUsrId = user?.usrId ?? user?.id ?? user?.userId ?? null;
        if (!clientUsrId) {
            Swal.fire({ text: "User id missing", icon: "error" });
            return;
        }

        const confirm = await Swal.fire({
            title: "Confirm purchase",
            text: `Proceed to create sale for KES ${Number(total || 0).toLocaleString()}`,
            icon: "question",
            showCancelButton: true,
            confirmButtonText: "Confirm",
        });
        if (!confirm.isConfirmed) return;

        setSaving(true);
        try {
            const headerPayload = {
                clientUsrId,
                totalSalePrice: Number(total) || 0,
                createdBy: username,
                createdDate: new Date().toISOString(),
                approvedYn: "P"
            };

            const res = await ServiceAPI.postSale(headerPayload);
            const created = res.data || {};
            const nshId = created?.nshId ?? created?.id ?? created?.nsh_id ?? created?.saleId ?? created;

            if (!nshId) {
                throw new Error("No sale header id returned");
            }

            for (const it of items) {
                const detailPayload = {
                    nshId,
                    srvId: it.srvId,
                    salePrice: Number(it.price) || 0,
                    saleUnits: Number(it.quantity) || 0,
                    createdBy: username,
                    createdDate: new Date().toISOString()
                };
                await ServiceAPI.postSaleDetail(detailPayload);
            }

            Swal.fire({ text: `Sale created`, icon: "success" });
            clear();
            navigate("/dashboard");
        } catch (err) {
            console.error(err);
            Swal.fire({ text: "Failed to create sale", icon: "error" });
        } finally {
            setSaving(false);
        }
    };

    return (
        <>
            <TopNavbar />
            <CheckoutWrap>
                <h2>Checkout</h2>
                <div>
                    {items.length === 0 ? (
                        <div>No items in cart.</div>
                    ) : (
                        <>
                            <table style={{ width: "100%", borderCollapse: "collapse" }}>
                                <thead><tr><th>Service</th><th style={{ textAlign: "right" }}>Price</th><th style={{ textAlign: "right" }}>Qty</th><th style={{ textAlign: "right" }}>Line</th></tr></thead>
                                <tbody>
                                    {items.map(it => (
                                        <tr key={it.srvId}>
                                            <td>{it.name}</td>
                                            <td style={{ textAlign: "right" }}>{Number(it.price || 0).toLocaleString()}</td>
                                            <td style={{ textAlign: "right" }}>{it.quantity}</td>
                                            <td style={{ textAlign: "right" }}>{(Number(it.price || 0) * Number(it.quantity || 0)).toLocaleString()}</td>
                                        </tr>
                                    ))}
                                </tbody>
                                <tfoot>
                                    <tr>
                                        <td colSpan={3} style={{ textAlign: "right", fontWeight: 700 }}>Total</td>
                                        <td style={{ textAlign: "right", fontWeight: 700 }}>{Number(total || 0).toLocaleString()}</td>
                                    </tr>
                                </tfoot>
                            </table>

                            <div style={{ marginTop: 16 }}>
                                <button onClick={handleCheckout} disabled={saving} style={{ padding: "10px 14px", borderRadius: 8, background: "#6a2cff", color: "#fff", border: 0 }}>
                                    {saving ? "Creating sale..." : "Make Sale"}
                                </button>
                            </div>
                        </>
                    )}
                </div>
            </CheckoutWrap>
        </>
    );
}

const CheckoutWrap = styled.div`
  padding: 24px;
  max-width: 900px;
  margin: 24px auto;
  margin-top: 100px; /* add this */
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 8px 30px rgba(16,24,64,0.06);
`;

